<template>
    <UApp :toaster="{ position: 'top-center' }">
        <NuxtLoadingIndicator />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
</template>

<script lang="ts" setup></script>
